<app-loading-spinner [active]="loading"></app-loading-spinner>

<form [formGroup]="form">
    <div class="row no-gutters w-100">
        <div class="col-12 col-lg-10">
            <ng-container *ngIf="showForm">
                <div class="row">
                    <div class="col-12 col-lg-4">
                        <app-masked-input [group]="form"
                            controlName="company_document_number" label="CNPJ"
                            mask="00.000.000/0000-00"
                            placeholder="00.000.000/0000-00">
                        </app-masked-input>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>

                    <div class="col-12 col-lg-6">
                        <app-input [group]="form" controlName="corporate_name"
                            [isUpperCase]="true" label="Razão Social"
                            placeholder="Digite">
                        </app-input>
                        <app-spacer [bottom]="48"></app-spacer>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-lg-6">
                        <app-button *ngIf="data.length === 0"
                            (onClick)="triggerForm()" [loading]="sending"
                            [disabled]="getDisabled()" class="add-button"
                            [outline]="true">
                            <svg-icon src="assets/images/icon-add.svg"
                                class="mr-2"></svg-icon>
                            Salvar grupo econômico
                        </app-button>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="!showForm">
                <div class="row">
                    <div class="col-12">
                        <app-table [columns]="columns" [data]="data"
                            (onRemove)="handleOpenRemoveModal($event)"
                            [haveEdit]="true"
                            (onEdit)="handleEditItem($event)"></app-table>
                        <app-spacer [bottom]="32"></app-spacer>
                    </div>

                </div>

                <div class="row">
                    <div class="col-12 col-lg-6">

                        <app-button *ngIf="data.length> 0"
                            (onClick)="triggerForm()" [disabled]="getDisabled()"
                            class="add-button" [outline]="true">
                            <svg-icon src="assets/images/icon-add.svg"
                                class="mr-2"></svg-icon>
                            Adicionar outro grupo econômico
                        </app-button>

                    </div>
                </div>
            </ng-container>
        </div>
    </div>

    <app-side-modal [active]="addAnotherModal" [title]="renderTitle()"
        (onClose)="handleCloseAddAnotherModal()" paddingBottom="0">
        <div class="container">
            <div class="row">
                <div class="col-12 col-lg-12">
                    <app-masked-input [group]="form"
                        controlName="company_document_number" label="CNPJ"
                        mask="00.000.000/0000-00" [errorText]="errorText"
                        placeholder="00.000.000/0000-00">
                    </app-masked-input>
                    <app-spacer [bottom]="24"></app-spacer>
                </div>

                <div class="col-12 col-lg-12">
                    <app-input [group]="form" controlName="corporate_name"
                        [isUpperCase]="true" label="Razão Social"
                        placeholder="Digite">
                    </app-input>
                    <app-spacer [bottom]="28"></app-spacer>
                </div>
            </div>

            <div class="row button-sticky">
                <div class="col-12 col-lg-6">
                    <app-button (onClick)="handleCloseAddAnotherModal()"
                        class="add-button" [outline]="true">
                        Cancelar
                    </app-button>
                </div>

                <div class="col-12 col-lg-6">
                    <div class="text-right">
                        <app-button (onClick)="triggerForm()"
                            [loading]="sending" [disabled]="getDisabled()"
                            class="add-button">
                            Salvar grupo econômico
                        </app-button>
                    </div>
                </div>
            </div>
        </div>
    </app-side-modal>

    <app-warning-modal [active]="removeModal"
        (onClose)="removingData ? null : handleRemoveCancel()">
        <h3>Você tem certeza?</h3>
        <app-spacer [bottom]="24"></app-spacer>
        <p>Você não poderá reverter essa ação!</p>
        <app-spacer [bottom]="56"></app-spacer>

        <app-button (onClick)="handleRemoveCancel()" [center]="true"
            class="add-button" [disabled]="removingData">
            Cancelar
        </app-button>

        <app-spacer [bottom]="8"></app-spacer>

        <app-button (onClick)="removeEconomic(selectedIndex)" class="add-button"
            [center]="true" [outline]="true" [loading]="removingData"
            [disabled]="removingData">
            Sim, apague!
        </app-button>
    </app-warning-modal>

</form>